<template>
  <div class="company">

    <div class="centre">
      <div class="imgText">
        <div class="pic" >
          <img src="@/assets/Maschine Robot 3.png">
        </div>
        <img class="picture" src="@/assets/mechanical.png">
        <div class="typeface">
          <p>
            Maschine Robot is a wearable robotics company based on technologies in wearable sensors, data intelligence,
            and human-machine interactions. Our R&D centers locate in Boston, US, and Beijing, China. Our core team
            consists of members with background in related technology industries and renowned universities.
          </p>
          <br />
          <p>
            Our key products are centered around wearables and human-machine integrative systems empowered by data
            intelligence. We aim to build a new paradigm, via incorporating wearables and artificial intelligence, of
            personal healthcare and interactions for the future, and to provide solutions for challenges stemmed from
            population ageing.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "company.vue",


  // data() {
  //   return {
  //     positionY1: 900,
  //     Y1: 0,
  //     ratio: 0.1,
  //   }
  // },
  // mounted() {
  //   window.addEventListener("scroll", this.handleScroll)
  //   let bgTest = document.querySelector('.centre')
  //   this.Y1 = bgTest.offsetTop * this.ratio
  // },
  // methods: {
  //   handleScroll() {
  //     let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  //     this.positionY1 = this.Y1 - scrollTop * this.ratio
  //   }
  // }
}
</script>

<style scoped>

* {
  margin: 0;
  padding: 0;
}

.company .centre {
  margin: 0 auto;
  background-image: url("../../../assets/science-img.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 900px;
  /*background-attachment: fixed;*/
}

.centre .imgText {
  margin: auto;
  width: 635px;
  padding: 139px 0 0 200px;
}

.centre .imgText .pic {
 line-height: 0;
}

.centre .imgText .pic img {
  width: 570px;
  height: 58px;
}


.centre .imgText .picture {
  height: 24px;
  margin-top: 65px;
  margin-bottom: 40px
}

.centre .imgText .diamond {
  position: absolute;
  bottom: -172px;
  right: -269px;
}

.centre .imgText .typeface {
  width: 858px;
}

.centre .imgText .typeface p {
  width: 858px;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 40px;
  color: #111111;
}

</style>
